import React, { useMemo } from 'react';
import Table from '../components/Table/Table';
import Columns from '../features/DishContainer/columns';
import useExcludedDishes from '../features/DishContainer/hooks/useExcludedDishes';
import useIncludeDishes from '../features/DishContainer/hooks/useIncludeDishes';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';

const DishesExcludedView = () => {
  const filter = useMemo(
    () => ({
      hasPpsi: false
    }),
    []
  );
  const [isFetching, dishesRaw] = useExcludedDishes(filter);
  const dishes = toJS(dishesRaw, []);
  const [includeDishes] = useIncludeDishes();
  View.ExcludedDishesView.visit();

  function clickIncludeDishes(selectedData, callback) {
    const formulaCodes = selectedData.map(row => row.data.formulaCode);
    includeDishes(formulaCodes);
    callback();
  }

  return (
    <PaperContainer showProgress={isFetching}>
      <Table
        title="dish.excludedDishesTitle"
        data={dishes}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          Columns.ModifyDate
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        showLanguageSelector={false}
        actions={[{ label: 'Include', onClick: clickIncludeDishes }]}
      />
    </PaperContainer>
  );
};

export default DishesExcludedView;
